var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("主人！你的页面被我不小心弄丢了.../哭")]),_c('div',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("点击回到首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }